/* Делаем первую букву заглавной */
export function firstLetterBig(str: string | undefined): string {
  if (!str) {
    return "Назад";
  }
  const firstChar = str.charAt(0).toUpperCase();
  const secondChar = str.slice(1);
  return firstChar + secondChar;
}

/* Mинуты превращаем в часы и минуты */
export function convertToHours(minutes: number) {
  const m = minutes % 60;
  const h = (minutes - m) / 60;
  return (
    (h < 10 ? "0" : "") +
    h.toString() +
    " ч " +
    (m < 10 ? "0" : "") +
    m.toString() +
    " мин"
  );
}
